module.exports = __webpack_public_path__ + "img/mf_logo.9b52b2e5.png";